import { Stack } from '@mui/material';
import AppDataGrid from '@shared/components/DataGrid';
import { useParams } from 'react-router-dom';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import AddTeamMemberButton from '../features/team/components/AddTeamMemberButton';
import { createTeamColumns } from '../features/team/components/teamTable/columns';
import { transformTeamMembersToRows } from '../features/team/entity';
import {
  useSuspenseTeamMembersQuery,
  useUpdateTeamMemberSkill,
  useDeleteTeamMemberMutation,
  SkillUpdateInput,
} from '../features/team/queries';
import { useAppNavigate } from '@shared/store';

const useTeamData = () => {
  const { teamId } = useParams();
  const navigate = useAppNavigate();
  const intl = useIntl();
  const { data: teamMembers } = useSuspenseTeamMembersQuery(teamId);
  const { mutate: updateTeamMemberSkill } = useUpdateTeamMemberSkill(teamId);
  const { mutate: deleteTeamMember } = useDeleteTeamMemberMutation();

  const teamMemberRows = useMemo(() => {
    return transformTeamMembersToRows(teamMembers);
  }, [teamMembers]);

  const handleUpdateSkill = (data: SkillUpdateInput) => {
    updateTeamMemberSkill(data);
  };

  const handleDeleteMember = (userId: string) => {
    deleteTeamMember(userId);
    navigate('/');
  };

  return {
    teamMemberRows,
    intl,
    handleUpdateSkill,
    handleDeleteMember,
  };
};

const Team = () => {
  const { teamMemberRows, intl, handleUpdateSkill, handleDeleteMember } = useTeamData();

  const columns = createTeamColumns(teamMemberRows, handleUpdateSkill, handleDeleteMember, intl);

  return (
    <Stack sx={{ height: '100%' }} spacing={2}>
      <AppDataGrid rows={teamMemberRows} columns={columns} />
      <AddTeamMemberButton />
    </Stack>
  );
};

export default Team;
